var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"trunk"}},[_c('lead'),_c('main',{class:[_vm.$route.name=='postEdit'?'':'main']},[_c('router-view')],1),(_vm.$route.name!='postEdit')?_c('foote'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }